import { CommonModule } from '@angular/common';
import { Component, Input, NgModule, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { StateService, UIRouterModule } from '@uirouter/angular';

import { MenuModule } from '@app/primeng-overrides/menu';
import { DividerModule } from 'primeng/divider';
import { PanelModule } from 'primeng/panel';
import { ToolbarModule } from 'primeng/toolbar';

import { StorageService } from '@app/_global/storage.service';
import { Abonne } from '@app/abonne/abonne.model';
import { AbonneService } from '@app/abonne/abonne.service';
import { NomenclatureSelectorModule } from '@app/nomenclature/nomenclature-selector';
import { Nomenclature, NomenclatureElementKey } from '@app/nomenclature/nomenclature.model';
import { extractNomenclatureElementIdFromKey, NomenclatureNodeData } from '@app/nomenclature/nomenclature.service';
import { SiteService, StatistiquesConformite } from '@app/site/site.service';
import { Utilisateur } from '@app/utilisateur/utilisateur.model';
import { GlobalModule } from '@global/global.module';
import { BlocStatistiquesModule } from './bloc-statistiques/bloc-statistiques';

@Component({
	selector: 'tableau-de-bord',
	templateUrl: `tableau-de-bord.html`
})
export class TableauDeBordComponent implements OnInit {

	@Input() me: Utilisateur;
	@Input() nomenclature_selection_key?: NomenclatureElementKey = undefined;

	loading: boolean = true;
	statistiquesConformite: StatistiquesConformite | null;

	abonne: Abonne;
	mergedNomenclatureDiagnostics: Nomenclature;
	nomenclatureFilter?: NomenclatureNodeData;

	constructor(
		private abonneService: AbonneService, 
		private siteService: SiteService,
		private stateService: StateService,
		private storageService: StorageService
	) {
		this.abonne = this.abonneService.currentAbonneValue!;
	}

	ngOnInit(): void {
		this.loading = true;
		this.siteService.getMergedNomenclatureDiagnostics(this.abonne.abo_id, this.abonne.sites.map(sit => sit.sit_id))
		.subscribe((nomenclature: Nomenclature) => {
			this.mergedNomenclatureDiagnostics = nomenclature;

			if (!this.nomenclature_selection_key) {
				let selectionKeyFromStorage = this.storageService.getForCurrentState('selectionKey', undefined, true);
				if (selectionKeyFromStorage && typeof selectionKeyFromStorage == 'string') {
					this.nomenclature_selection_key = selectionKeyFromStorage as NomenclatureElementKey;
				}
			}
			this.storageService.setForCurrentState('selectionKey', this.nomenclature_selection_key, true);
			
			let fam_id: number | undefined;
			let thm_id: number | undefined;

			if (this.nomenclature_selection_key) {
				let id = extractNomenclatureElementIdFromKey(this.nomenclature_selection_key)
				if ('fam_id' in id) {
					fam_id = id.fam_id;
				}
				if ('thm_id' in id) {
					thm_id = id.thm_id;
				}
			}

			this.siteService.getStatsConformite(this.abonne.abo_id, fam_id, thm_id)
			.subscribe((stats: StatistiquesConformite) => {
				this.statistiquesConformite = stats;
			})
			.add(() => {
				this.loading = false;
			});
		});
	}

	nomenclatureSelectionChange(event: any) {
		if (this.nomenclatureFilter) {
			this.nomenclature_selection_key = this.nomenclatureFilter.key;
		}
		else {
			this.nomenclature_selection_key = undefined;
		}
		this.storageService.setForCurrentState('selectionKey', this.nomenclature_selection_key, true);

		let fam_id: number | undefined;
		let thm_id: number | undefined;
		let uiParams = {nomenclature_selection_key: this.nomenclature_selection_key};

		if (this.nomenclature_selection_key) {
			let id = extractNomenclatureElementIdFromKey(this.nomenclature_selection_key)
			if ('fam_id' in id) {
				fam_id = id.fam_id;
			}
			if ('thm_id' in id) {
				thm_id = id.thm_id;
			}
		}

		this.loading = true;
		this.siteService.getStatsConformite(this.abonne.abo_id, fam_id, thm_id)
		.subscribe((stats: StatistiquesConformite) => {
			this.statistiquesConformite = stats;
			this.stateService.go('.', uiParams, { reload: false, location: 'replace', inherit: true });
		})
		.add(() => {
			this.loading = false;
		});
	}

}

@NgModule({
	imports: [
    CommonModule,
    GlobalModule,
    UIRouterModule,
    FormsModule,
    ToolbarModule,
    MenuModule,
    PanelModule,
    DividerModule,
    BlocStatistiquesModule,
    NomenclatureSelectorModule,
],
	exports: [TableauDeBordComponent],
	declarations: [TableauDeBordComponent]
})
export class TableauDeBordModule { }
